import React, { useState } from 'react';
import styled from 'styled-components';
import { API } from 'aws-amplify';

//Components
import { ColumnFlexPage } from '../components/Page'
import { StreamSelector } from '../components/StreamSelector'
import { Button } from '../components/BasicControls'
import { StatusBadge } from '../components/StatusBadge'


const LessFuglyTable = styled.table `
  background-color: white;
  border-collapse: collapse;
  padding: 1rem;

  td th{
    border-bottom: 1px solid lightgray;
    padding: 16px;
  }
`

// Fixed display order for region columns. Only regions present in the response
// are rendered, but when present they appear in this order.
const REGION_ORDER = [
  "iad-1", "iad-2", "pdx-1", "pdx-2", "sfo-1", "sfo-2",
  "lhr-1", "lhr-2", "dub-1", "dub-2", "fra-1", "fra-2",
]

// Split a fully-qualified stream name ("feedp1-iad-1") into its bare feed name
// ("feedp1") and region suffix ("iad-1"). Returns null if it doesn't match.
function splitName(name) {
  const m = /^(.*)-([a-z]{3}-\d+)$/.exec(name || "")
  if (!m) return null
  return { feed: m[1], region: m[2] }
}

// Pivot the flat [{name, hls_monitoring_url}] response into a single row per
// feed with one column per region that returned a URL:
//   { columns: ["iad-1","iad-2",...], rows: [{ feed, urls: {region: url} }] }
function pivot(response) {
  const byFeed = {}
  const regionsPresent = new Set()
  response.forEach(item => {
    const parts = splitName(item.name)
    if (!parts) return
    regionsPresent.add(parts.region)
    if (!byFeed[parts.feed]) byFeed[parts.feed] = {}
    byFeed[parts.feed][parts.region] = item.hls_monitoring_url
  })
  const columns = REGION_ORDER.filter(r => regionsPresent.has(r))
  const rows = Object.keys(byFeed).sort().map(feed => ({ feed, urls: byFeed[feed] }))
  return { columns, rows }
}


export default function HlsMonUrls() {

  const [streamName, setStreamName] = useState("")
  const [report, setReport] = useState({ columns: [], rows: [] })
  const [errorText, setErrorText] = useState("")
  const [status, setStatus] = useState("Ready")

  function copytable(id) {
    var urlField = document.getElementById(id)
    var range = document.createRange()
    var selection = window.getSelection()
    range.selectNode(urlField)
    selection.removeAllRanges(); // Remove all ranges from the selection.
    selection.addRange(range); // Add the new range.
    document.execCommand('copy')
  }

  // Fetches P1 HLS monitoring URLs (name, hls_monitoring_url) from the
  // emp_management lambda. Only P1 feeds return data; the backend expands the
  // input across every subregion in its realm. The response is pivoted into a
  // single feed row with one column per region for easy spreadsheet paste.
  async function runReport() {
    setStatus("Running")
    setErrorText("")
    await API.get(
        process.env.REACT_APP_API_ENVIRONMENT, //API endpoints are configured per environment
        'emp_management/read', {
          headers: {
            'Cache-Control': 'max-age=87000',
            'Content-type': 'application/json',
          },
          queryStringParameters: {
            action: 'get_hls_monitoring_urls',
            stream_name: streamName
          }
        })
      .then(response => {
        console.log(response)
        if (Array.isArray(response) && response.length > 0) {
          setReport(pivot(response))
          setStatus("Success")
        } else {
          setReport({ columns: [], rows: [] })
          setStatus("Error")
          setErrorText("No P1 HLS monitoring URLs found for '" + streamName + "'.")
        }
      })
      .catch(error => {
        console.log(error)
        setReport({ columns: [], rows: [] })
        setStatus("Error")
        if (error.response !== undefined && error.response.data !== undefined) {
          setErrorText(JSON.stringify(error.response.data))
        } else {
          setErrorText("Error attempting to fetch HLS monitoring URLs")
        }
      });
  }

  return (
    <ColumnFlexPage style={{paddingLeft:"30px", paddingRight:"50px", paddingTop:"10px", boxSizing:"border-box", width:"100vw", backgroundColor:"white"}}>
          <div name="Header" style={{display:"flex", justifyContent:"space-between"}}>
            <h1>HLS Monitoring URLs</h1>
            <StatusBadge status={status}/>
          </div>

          <div name="Data Entry" style={{display:"grid", gridTemplateColumns: "1fr repeat(2, fit-content(30rem))", columnGap:"10px",marginBottom:"25px"}}>
              <StreamSelector placeholder="Stream Name" onChange={(e) => setStreamName(e.target.value)}/>
              <Button style={{width:"10rem", borderRadius:"2px"}} onClick={() => runReport()} >Output URLs</Button>
              <Button style={{width:"10rem", borderRadius:"2px"}} onClick={() => copytable("report")}>Copy to Clipboard</Button>
          </div>
          { report.rows.length > 0 ?
          <div style={{overflowX:"scroll", border:"2px solid #333"}}>
            <LessFuglyTable id="report">
              <thead>
                <tr>
                  <th>feed name</th>
                  {report.columns.map((region, index) => (
                    <th key={index}>{region}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {report.rows.map((row, index) => (
                  <tr key={index}>
                    <td>{row.feed}</td>
                    {report.columns.map((region, cidx) => (
                      <td key={cidx}>{row.urls[region] || ""}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </LessFuglyTable>
          </div>
           :
            <pre>{errorText}</pre>
          }
        </ColumnFlexPage>
  );
}
